/**
 *
 * Specific selectors for  retrieving elements in the store.
 * This is a private module.
 * The selector pattern is an abstraction that standardizes geo application’s
 * store querying logic.
 *
 *
 * @module geo/store/selectors
 * @private
 * @preferred
 * @hidden
 */

import { createSelector } from "reselect";

import { MapOptions } from "../types/map";
import { IHashEntry } from "../types/map/layer/map.entry";

import { AppStore } from "./app";
import { FunctionalityOptions } from "../types/functionality";
import { ServiceOperation, IHashServicesOperations } from "../types/services";
import { Feature } from "../types/feature";
import { KindService } from "../types/services/kind.service";
/**
 * @hidden
 * @private
 */
const intializeSelector = (state: AppStore): boolean | undefined =>
  state.iframeInitialized;
/**
 * @hidden
 * @private
 */
const mapSelector = (state: AppStore): MapOptions | null | undefined =>
  state.map;
/**
 * @hidden
 * @private
 */
const selectionSelector = (state: AppStore) => state.selection;


/**
 * @hidden
 * @private
 */
const servicesSelector = (state: AppStore) => state.servicesOperations;


/**
 * @hidden
 * @private
 */
const functionalitySelector = (
  state: AppStore,
  id: string
): FunctionalityOptions | {} => {
  if (
    id !== undefined &&
    state.functionalities !== undefined &&
    state.functionalities.hasOwnProperty(id) &&
    state.functionalities[id] !== undefined
  ) {
    return state.functionalities[id];
  }
  return {};
};

/**
 * @hidden
 * @private
 */
const mapEntriesSelector = (state: AppStore): IHashEntry => {
  if (
    state.map !== undefined &&
    state.map !== null &&
    state.map.entries !== undefined
  ) {
    return state.map.entries;
  }
  return {};
};
/**
 * @hidden
 * @private
 */
const appInitializeSelector = (state: AppStore): boolean | undefined =>
  state.applicationInitialized;

export { MapOptions };
export { IHashEntry };
/**
 * @hidden
 * @private
 */
export const stateOfApp = createSelector(
  intializeSelector,
  appInitializeSelector,
  (init: boolean | undefined, app: boolean | undefined) => {
    let stateApp = 1;

    if (init && !app) {
      stateApp = 2;
    }
    if (init && app) {
      stateApp = 3;
    }
    return stateApp;
  }
);
/**
 * @hidden
 * @private
 */
export const appInitialized = createSelector(
  intializeSelector,
  appInitializeSelector,
  (init: boolean | undefined, app: boolean | undefined) => {
    let stateApp = 1;

    if (init && !app) {
      stateApp = 2;
    }
    if (init && app) {
      stateApp = 3;
    }
    if (stateApp === 3) {
      return true;
    }
    return false;
  }
);
/**
 * @hidden
 * @private
 */
export const stateOMap = createSelector(
  mapSelector,
  (map: MapOptions | null | undefined) => {
    // nothind to do for the moment
    return map;
  }
);
/**
 * @hidden
 * @private
 */
export const stateOMapEntries = createSelector(
  mapEntriesSelector,
  (mapEntry: IHashEntry) => {
    // nothind to do for the moment
    return mapEntry;
  }
);
/**
 * @hidden
 * @private
 */
export const stateOfSelection = createSelector(
  selectionSelector,
  (features: Feature[] | undefined) => {
    // nothind to do for the moment
    return features;
  }
);
/**
 * @hidden
 * @private
 */
export const stateOfFunctionality = createSelector(
  functionalitySelector,
  (functionality: {} | FunctionalityOptions) => {
    // nothind to do for the moment
    return functionality;
  }
);

/**
 * @hidden
 * @private
 */
export const stateOfSearchsService=createSelector(
  servicesSelector,
  (services: {} |   IHashServicesOperations) => {
    // nothind to do for the moment
    let servicesStates:IHashServicesOperations={};
    for (const aService of Object.values(services)) {
      if(aService.type==KindService.EXECUTE_SEARCH){
        servicesStates[aService.id]=aService;
      }
      // use color here
    }
    return servicesStates;
  }

)